export default "__VITE_ASSET__a737aa9f__"